export const Certifications = [
    {
        name: "AWS Certified Developer - Associate",
        acquired: "June 14, 2024",
        expiration: "June 14, 2027",
    },
    {
        name: "AWS Certified: Cloud Practitioner",
        acquired: "May 14, 2022",
        expiration: "June 14 2027",
    },
    {
        name: "Microsoft Certified: Azure Fundamentals",
        acquired: "August 12 2022",
        expiration: "N/A",
    },
    {
        name: "IBM Certified Advocate - Cloud",
        acquired: "April 06 2022",
        expiration: "N/A",
    },
    
]